import styled from 'styled-components';
import { COLORS, DEVICES, pickThemeFontStyles } from '@/theme';

export const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  min-height: 100vh;
  padding: 1rem;
  overflow-x: hidden;
  background-color: ${COLORS.WHITE};
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;

  @media screen and ${DEVICES.LAPTOP_S} {
    background-color: ${COLORS.BRIGHT_GRAY};
    padding: 1.5rem 2rem 2rem;
  }
`;

export const StyledHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
`;

export const StyledHeaderText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const StyledPageTitle = styled.h1`
  margin: 0;
  ${pickThemeFontStyles('24', '32', 'BOLD')};
  color: ${COLORS.BLACK};
  overflow: visible;
`;

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const StyledEmptyState = styled.div`
  ${pickThemeFontStyles('14', '22', 'NORMAL')};
  color: ${COLORS.GRAY_PRIMARY};
  padding: 2rem 0;
  text-align: center;
`;

export const StyledBottomGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;

  @media screen and ${DEVICES.LAPTOP_S} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;
